export default {
  root: {
    display: 'table-row',
  },
  cell: {
    display: 'table-cell',
  },
  cellIcon: {
    paddingRight: '0.5rem',
  },
  icon: {
    marginRight: '0.05em',
    position: 'relative',
    top: '-0.1em',
    color: ({ theme, withAccent }: Object) =>
      withAccent ? theme.accentColor : 'inherit',
  },
};
